import { FC, memo } from 'react'
import { Flex, Image, Text } from '@chakra-ui/react'

import { Citizen, CitizenFilter } from 'CitizenProfile/types'
import getAssets from 'utils/assets/getAssets'
import { cnsMask, cpfMask, pisMask, rgMask } from 'utils/masks'
import { Highlight } from 'components'

type CitizenDocumentsFields = {
  cpf: boolean
  cns: boolean
  pis: boolean
  rg: boolean
}

type Props = {
  citizenFilter?: CitizenFilter
  citizen: Citizen
  citizenDocumentsFields: CitizenDocumentsFields
}

const CitizenCardDocuments: FC<Props> = ({ citizenFilter, citizen, citizenDocumentsFields }) => {
  const CPFImage = getAssets('Document', 'cpf')
  const CNSImage = getAssets('Document', 'cns')
  const PISImage = getAssets('Document', 'ctps')
  const RGImage = getAssets('Document', 'rg')

  const isAtLeastOneEnabledField = Object.values(citizenDocumentsFields).some((isTrue) => isTrue)

  return (
    <Flex direction="column" width="100%" gap={2}>
      {isAtLeastOneEnabledField && <Text variant="secondary">Documentos</Text>}

      <Flex direction="column" gap={1}>
        {citizenDocumentsFields.cpf && (
          <Flex align="center" gap={1}>
            <Image boxSize={6} src={CPFImage} alt="CPF" />
            <Text variant="secondary">CPF: </Text>
            <Text>
              <Highlight query={cpfMask(citizenFilter?.cpf_number as string)}>{cpfMask(citizen.cpf_number)}</Highlight>
            </Text>
          </Flex>
        )}

        {citizenDocumentsFields.cns && (
          <Flex align="center" gap={1}>
            <Image boxSize={6} src={CNSImage} alt="CNS" />
            <Text variant="secondary">CNS: </Text>
            <Text>
              <Highlight query={cnsMask(citizenFilter?.cns_number as string)}>{cnsMask(citizen.cns_number)}</Highlight>
            </Text>
          </Flex>
        )}

        {citizenDocumentsFields.pis && (
          <Flex align="center" gap={1}>
            <Image boxSize={6} src={PISImage} alt="PIS" />
            <Text variant="secondary">PIS: </Text>
            <Text>
              <Highlight query={pisMask(citizenFilter?.ctps_pis_number as string)}>{pisMask(citizen.ctps_pis_number)}</Highlight>
            </Text>
          </Flex>
        )}

        {citizenDocumentsFields.rg && (
          <Flex align="center" gap={1}>
            <Image boxSize={6} src={RGImage} alt="RG" />
            <Text variant="secondary">RG: </Text>
            <Text>
              <Highlight query={rgMask(citizenFilter?.rg_number) as string}>{rgMask(citizen.rg_number)}</Highlight>
            </Text>
          </Flex>
        )}
      </Flex>
    </Flex>
  )
}

export default memo(CitizenCardDocuments)
